module.exports = __webpack_public_path__ + "img/s3.c32ebf3d.png";